import { Tabs, Tab, Container } from '@mui/material'
import { TabContext } from '@mui/lab'
import ScienceIcon from '@mui/icons-material/Science'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

function a11yProps(index: number) {
  return {
    id: `radiopharmacy-tab-${index}`,
    'aria-controls': `radiopharmacy-tabpanel-${index}`,
  }
}

export default function RadiopharmacyHub() {
  const navigate = useNavigate()
  const location = useLocation()

  const tabIndex = location.pathname.includes('waste')
    ? 1
    : location.pathname.includes('prescription')
    ? 2
    : 0

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    if (newValue === 0) navigate('operation')
    else if (newValue === 1) navigate('waste')
    else navigate('prescription')
  }

  return (
    <>
      <TabContext value={String(tabIndex)}>
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          aria-label="radiopharmacy tabs"
          sx={{
            backgroundColor: 'white',
            minHeight: '40px',
            '& .MuiTab-root': {
              minHeight: '40px',
              padding: '4px 12px',
              fontSize: '0.875rem',
            },
            '& .MuiTab-iconWrapper': { marginRight: '8px' },
          }}
        >
          <Tab
            icon={<ScienceIcon />}
            iconPosition="start"
            label="Opérations"
            {...a11yProps(0)}
          />

          <Tab
            icon={<DeleteOutlineIcon />}
            iconPosition="start"
            label="Gestion déchets"
            {...a11yProps(1)}
          />

          <Tab
            icon={<ReceiptLongIcon />}
            iconPosition="start"
            label="Prescriptions"
            {...a11yProps(2)}
          />
        </Tabs>
      </TabContext>

      <Container maxWidth={false} className="mt-4 p-[30px] !w-[calc(100vw-120px)]
        bg-white rounded-[15px_15px_25px_25px] flex flex-col items-start"
        sx={{ height: { xs: 'auto', md: 'calc(100vh - 120px)' }, overflow: { xs: 'visible', md: 'hidden' }, pb: { xs: 8, md: 2 } }}>
        <Outlet />
      </Container>
    </>
  )
}
